import NumberAnswer from './NumberAnswer.component';

export default NumberAnswer;
